import { render, staticRenderFns } from "./TabBar.vue?vue&type=template&id=4becb413&scoped=true&"
import script from "./TabBar.vue?vue&type=script&lang=js&"
export * from "./TabBar.vue?vue&type=script&lang=js&"
import style0 from "./TabBar.vue?vue&type=style&index=0&id=4becb413&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4becb413",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/ubq-h5_build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4becb413')) {
      api.createRecord('4becb413', component.options)
    } else {
      api.reload('4becb413', component.options)
    }
    module.hot.accept("./TabBar.vue?vue&type=template&id=4becb413&scoped=true&", function () {
      api.rerender('4becb413', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/base/TabBar.vue"
export default component.exports